import "./index.css";

function Header(props) {
  return (
    <div className={props.shouldPrintHeader ? "Header" : "Header Invisible"}>
      <div className="header-orb header-orb-1"></div>
      <div className="header-orb header-orb-2"></div>
      <div className="header-orb header-orb-3"></div>
      <div className="Logo">{props.title}</div>
    </div>
  );
}

export default Header;
